<div class="flex-container">
  <div class="flex-row">
    <div class="flex-col-auto strategy-footer">
      <div class="strategy-footer-protected">
        <ng-container *ngIf="!hideGuarantee && currentAccount.step_status !== 5">
          <app-guarantee-shield (guaranteeModal)="toggleGuaranteeModal()"></app-guarantee-shield>
        </ng-container>
      </div>
      <div class="strategy-footer-actions">
        <ng-content></ng-content>
<!-- TODO: 20.02.2026 Temporary disabled till we figure out the problem with the script-->
<!--        <div *ngIf="!hideGuarantee" class="zendesk footer" (click)="launchZendesk()">-->
<!--          <span class="icon-i-question"></span>-->
<!--          {{ 'nav.help' | translate }}-->
<!--        </div>-->
      </div>
    </div>
  </div>
  <app-guarantee *ngIf="showGuarantee" (guaranteeOpened)="toggleGuaranteeModal()"></app-guarantee>
</div>
